import { Directive, Input, TemplateRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
  selector: 'ng-template[appStepperStep]',
})
export class StepperStepDirective {
  @Input() label: string = '';
  @Input() stepControl: AbstractControl | null = null;
  @Input() completed?: boolean;
  @Input() optional = false;
  @Input() editable = true;

  constructor(public templateRef: TemplateRef<any>) {}
}
